import $ from 'jquery'
import Swiper from "./swiper.min";

$(document).ready(function () {
    var dim = $(".dim");

    // @Gnb
    var gnb = $(".header_bottom .gnb");
    var gnbDep2 = gnb.find(".dep2");
/*    var gnbDep2H = gnbDep2.outerHeight();*/
    var gnbBg = $(".gnb_bg");

    gnb.on("mouseover focusin", function () {
        if (searchBtn.hasClass("active")) {
            searchBtn.click();
        }
        gnbDep2.stop().fadeIn(100);
        gnbBg.stop().slideDown(200);
       /* gnbBg.height(gnbDep2H).stop().slideDown(200);*/
        dim.show();
    });
    gnb.on("mouseleave focusout", function () {
        gnbDep2.stop().fadeOut(100);
        gnbBg.stop().slideUp(200);
        dim.stop().hide();
    });

    // @Total Search
    var search = $(".total_search");
    var searchBtn = $(".header .btn_search");

    searchBtn.on("click", function () {
        if (!$(this).hasClass("active")) {
            $(this).addClass("active");
            search.stop().show().find("input").focus();
            dim.show();
        } else {
            $(this).removeClass("active");
            search.stop().hide();
            dim.hide();
        }
    });

    // @Mobile Menu
    var mMenu = $(".mobile_menu");
    var mMenuOpen = $(".header .btn_menu");
    var mMenuClose = mMenu.find(".btn_close");

    mMenuOpen.on("click", function () {
        mMenu.stop().show();
        dim.css("z-index", "998").stop().show();
    });
    mMenuClose.on("click", function () {
        mMenu.stop().hide();
        dim.css("z-index", "0").stop().hide();
    });

    // @Mobile Gnb Menu
    var mMenuList = $(".mobile_menu .menu");
    var mMenuListDep1 = mMenuList.find("strong");

    mMenuListDep1.on("click", function () {
        if (!$(this).parent("li").hasClass("active")) {
            mMenuList.children("li").removeClass("active").find(".dep2").slideUp();
            $(this).parent("li").addClass("active").children().siblings("ul").stop().slideDown();
        } else {
            $(this).parent("li").removeClass("active").children().siblings("ul").stop().slideUp();
        }
    });

    //@ Sub Page Category
    $(".board_category").each(function () {
        var swiper = new Swiper($(this), {
            slidesPerView: "auto",
            spaceBetween: 24,
            freeMode: true,
            breakpoints: {
                767: {
                    spaceBetween: 16,
                },
            },
        });
    });

    //@ Comment Reply
    $(".board_comment .btn_reply").on("click", function () {
        $(this).closest("li").children(".dep2").stop().toggle();
    });

    //@ Learning Audio Button
    var audio = $(".audio_box .audio");
    $(".audio_box .btn_play").on("click", function () {
        audio.get(0).play();
    });
    $(".audio_box .btn_pause").on("click", function () {
        audio.get(0).pause();
    });
});
